<template>
  <div class="pk-classic-page pk-account-panel">
    <section class="pk-classic-shell">
      <header class="pk-classic-header">
        <h1>经典轮盘</h1>
        <div class="pk-classic-actions">
          <button @click="openPanel('guide')">玩法介绍</button>
          <button @click="openPanel('history')">历史记录</button>
        </div>
      </header>

      <section class="pk-classic-main">
        <aside class="pk-classic-rail">
          <span></span>
        </aside>

        <div class="pk-classic-content">
          <section class="pk-classic-hero">
            <div class="pk-classic-watermark wm-one">PIZZA<br />KING</div>
            <div class="pk-classic-watermark wm-two">PIZZA<br />KING</div>
            <div class="pk-classic-watermark wm-three">PIZZA<br />KING</div>

            <div class="pk-bank-block">
              <strong>奖池:</strong>
              <span>0 <i></i></span>
            </div>

            <div class="pk-classic-clock">
              <div class="pk-clock-row">
                <b>0</b>
                <b>0</b>
                <em>:</em>
                <b>0</b>
                <b>0</b>
              </div>
              <span>本轮<br />#0</span>
            </div>

            <div class="pk-chance-block">你的概率 - 0%</div>

            <div class="pk-items-counter">饰品数量 - /100</div>

            <div class="pk-rule-block">
              <span>最小投入 - 1</span>
              <span>单次最多饰品 - 15</span>
            </div>
          </section>

          <section class="pk-deposit-zone">
            <button @click="openPanel('deposit')">立即投入</button>
          </section>

          <section class="pk-classic-stats">
            <article v-for="item in stats" :key="item.label">
              <div>
                <strong>{{ item.label }}</strong>
                <b>{{ item.value }}</b>
              </div>
            </article>
          </section>
        </div>
      </section>
    </section>

    <div v-if="panel" class="pk-classic-modal" @click.self="closePanel">
      <section class="pk-classic-modal-card">
        <button class="pk-classic-modal-close" @click="closePanel">×</button>
        <template v-if="panel === 'guide'">
          <span>玩法介绍</span>
          <h2>经典轮盘</h2>
          <p>查看玩法说明和历史记录。</p>
        </template>
        <template v-else-if="panel === 'history'">
          <span>历史记录</span>
          <h2>最近奖池</h2>
          <template v-if="history.length">
            <div class="pk-classic-history-row" v-for="item in history" :key="item.round">
              <strong>{{ item.round }}</strong><span>{{ item.winner }}</span><b>{{ item.value }}</b>
            </div>
          </template>
          <p v-else class="pk-classic-history-empty">暂无已结算经典轮盘记录</p>
        </template>
        <template v-else>
          <span>投入物品</span>
          <h2>本轮奖池尚未开放</h2>
          <p>本模式暂未开放。</p>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Classic",
  data() {
    return {
      stats: [
        { label: "最近赢家", value: "暂无数据" },
        { label: "今日最幸运", value: "暂无数据" },
        { label: "最大投入", value: "暂无数据" },
      ],
      history: [],
      panel: "",
    };
  },
  methods: {
    openPanel(panel) {
      this.panel = panel;
    },
    closePanel() {
      this.panel = "";
    },
    notify() {
      this.$message({
        message: "经典模式暂未开放。",
        type: "info",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.pk-classic-page {
  min-height: calc(100vh - 198px);
  padding: 0 0 90px;
  color: #f4f6ff;
  background: #1f212c;
}

button {
  font-family: inherit;
  cursor: pointer;
}

.pk-classic-shell {
  width: 100%;
  max-width: 1540px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 28px;
}

.pk-classic-header {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.065);
}

.pk-classic-header h1 {
  margin: 0;
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 20px;
  line-height: 1;
  font-weight: 1000;
}

.pk-classic-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pk-classic-actions button {
  min-width: 124px;
  height: 40px;
  padding: 0 20px;
  color: #fff;
  background: #272a38;
  border: 0;
  border-radius: 4px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  font-weight: 1000;
}

.pk-classic-main {
  min-height: 820px;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
}

.pk-classic-rail {
  width: 48px;
  min-height: 820px;
  display: grid;
  justify-items: center;
  align-content: start;
  padding-top: 33px;
  background: #1c1f2b;
  border-left: 1px solid rgba(255, 255, 255, 0.065);
  border-right: 1px solid rgba(255, 255, 255, 0.065);
}

.pk-classic-rail span {
  width: 26px;
  height: 26px;
  display: block;
  position: relative;
  border: 3px solid #00e8f4;
  border-radius: 9px;
}

.pk-classic-rail span::before {
  content: "";
  width: 10px;
  height: 7px;
  position: absolute;
  left: 50%;
  top: -8px;
  border: 3px solid #00e8f4;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  transform: translateX(-50%);
}

.pk-classic-rail span::after {
  content: "";
  width: 12px;
  height: 3px;
  position: absolute;
  left: 4px;
  top: 10px;
  background: #00e8f4;
  box-shadow: 0 6px 0 #00e8f4;
}

.pk-classic-content {
  min-width: 0;
  background: #1f212c;
}

.pk-classic-hero {
  height: 262px;
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.065);
  background:
    radial-gradient(circle at 51% 46%, rgba(29, 223, 198, 0.24), rgba(36, 94, 99, 0.18) 28%, transparent 56%),
    linear-gradient(90deg, rgba(25, 31, 43, 0.98), rgba(31, 52, 58, 0.92) 48%, rgba(25, 31, 43, 0.98));
}

.pk-classic-hero::before,
.pk-classic-hero::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.pk-classic-hero::before {
  background:
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 0 1px, transparent 1px) 0 0 / 64px 100%,
    radial-gradient(circle at 15% 0, rgba(0, 255, 239, 0.06), transparent 30%);
  opacity: 0.42;
}

.pk-classic-hero::after {
  background: linear-gradient(180deg, rgba(24, 27, 37, 0), rgba(24, 27, 37, 0.38));
}

.pk-classic-watermark {
  position: absolute;
  z-index: 1;
  color: rgba(255, 255, 255, 0.045);
  font-size: 28px;
  line-height: 0.82;
  font-weight: 1000;
  text-align: center;
  transform: rotate(-75deg);
}

.wm-one {
  left: 250px;
  top: 72px;
}

.wm-two {
  left: 790px;
  top: 34px;
  transform: rotate(18deg);
}

.wm-three {
  right: 174px;
  top: 68px;
  transform: rotate(105deg);
}

.pk-bank-block {
  position: absolute;
  left: 32px;
  top: 45px;
  z-index: 2;
}

.pk-bank-block strong {
  display: block;
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 28px;
  line-height: 1;
  font-weight: 1000;
}

.pk-bank-block span {
  margin-top: 7px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ffca3c;
  font-size: 16px;
  font-weight: 1000;
}

.pk-bank-block i {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-classic-clock {
  width: 310px;
  position: absolute;
  left: 50%;
  top: 54px;
  z-index: 2;
  text-align: center;
  transform: translateX(-50%);
}

.pk-clock-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.pk-clock-row b {
  width: 50px;
  height: 80px;
  display: grid;
  place-items: center;
  color: #fff;
  background: rgba(13, 25, 32, 0.82);
  border-radius: 4px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 64px;
  line-height: 1;
  font-weight: 400;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.02);
}

.pk-clock-row em {
  margin: 0 4px;
  color: #fff;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 64px;
  line-height: 1;
  font-style: normal;
  font-weight: 400;
}

.pk-classic-clock span {
  margin-top: 32px;
  display: block;
  color: rgba(244, 246, 255, 0.7);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  line-height: 1.15;
  font-weight: 1000;
}

.pk-chance-block {
  position: absolute;
  right: 27px;
  top: 38px;
  z-index: 2;
  color: rgba(244, 246, 255, 0.76);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 13px;
  font-weight: 1000;
}

.pk-items-counter {
  position: absolute;
  left: 32px;
  bottom: 35px;
  z-index: 2;
  color: rgba(244, 246, 255, 0.65);
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  font-weight: 1000;
}

.pk-rule-block {
  position: absolute;
  right: 28px;
  bottom: 33px;
  z-index: 2;
  display: grid;
  gap: 5px;
  color: rgba(244, 246, 255, 0.7);
  text-align: right;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 14px;
  font-weight: 1000;
}

.pk-deposit-zone {
  height: 100px;
  display: grid;
  place-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.pk-deposit-zone button {
  width: 300px;
  height: 40px;
  color: #071b21;
  background: linear-gradient(90deg, #11f6cb, #17b4e8);
  border: 0;
  border-radius: 24px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 16px;
  font-weight: 1000;
  box-shadow: 0 0 24px rgba(17, 246, 203, 0.3);
}

.pk-classic-stats {
  margin: 0 18px;
  padding-top: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.pk-classic-stats article {
  height: 78px;
  padding-left: 70px;
  display: grid;
  align-content: center;
  border-radius: 9px;
  background: #223945;
}

.pk-classic-stats strong,
.pk-classic-stats span {
  display: block;
  font-family: Georgia, "Times New Roman", serif;
  font-weight: 1000;
}

.pk-classic-stats strong {
  color: #ffca3c;
  font-size: 17px;
}

.pk-classic-stats span {
  margin-top: 6px;
  color: #fff;
  font-size: 14px;
}

.pk-classic-modal {
  position: fixed;
  z-index: 80;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(8, 15, 18, 0.76);
}

.pk-classic-modal-card {
  width: 470px;
  max-width: 100%;
  position: relative;
  padding: 30px;
  color: #f4ead8;
  border: 1px solid rgba(17, 246, 203, 0.28);
  border-radius: 9px;
  background: radial-gradient(circle at 50% 0, rgba(17, 246, 203, 0.13), transparent 52%), #20222f;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.48);
}

.pk-classic-modal-card > span {
  color: #11f6cb;
  font-size: 12px;
  font-weight: 1000;
  letter-spacing: 0.12em;
}

.pk-classic-modal-card h2 {
  margin: 8px 0 14px;
  color: #fff7df;
  font-size: 24px;
}

.pk-classic-modal-card p {
  margin: 0;
  color: #b5becd;
  font-size: 14px;
  line-height: 1.8;
}

.pk-classic-modal-close {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f4ead8;
  border: 0;
  background: transparent;
  font-size: 28px;
  line-height: 1;
}

.pk-classic-history-row {
  min-height: 46px;
  padding: 0 12px;
  display: grid;
  grid-template-columns: 0.72fr 1fr 0.5fr;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  color: #b5becd;
  font-size: 13px;
}

.pk-classic-history-row strong { color: #fff7df; }
.pk-classic-history-row b { color: #11f6cb; text-align: right; }

.pk-classic-history-empty {
  margin: 24px 0 8px;
  padding: 18px;
  color: #97a1b4;
  text-align: center;
  border: 1px dashed rgba(255, 255, 255, 0.13);
  border-radius: 6px;
}

@media (max-width: 1280px) {
  .pk-classic-shell {
    padding: 0 24px;
  }

  .pk-classic-stats {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 760px) {
  .pk-classic-shell {
    padding: 0 14px;
  }

  .pk-classic-header {
    height: auto;
    padding: 18px 0;
    align-items: flex-start;
    flex-direction: column;
  }

  .pk-classic-main {
    grid-template-columns: 1fr;
  }

  .pk-classic-rail {
    display: none;
  }

  .pk-classic-hero {
    height: 420px;
  }

  .pk-bank-block,
  .pk-chance-block,
  .pk-items-counter,
  .pk-rule-block {
    left: 18px;
    right: auto;
    text-align: left;
  }

  .pk-chance-block {
    top: 118px;
  }

  .pk-rule-block {
    bottom: 18px;
  }

  .pk-classic-clock {
    top: 176px;
  }
}

/* 2026-07-05 exact-pass: classic public empty-game target layout. */
.pk-classic-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  background:
    radial-gradient(ellipse at 52% 220px, rgba(17, 246, 203, 0.06), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 430px, #171923 100%) !important;
}

.pk-classic-shell {
  max-width: none !important;
  padding: 0 24px 94px !important;
}

.pk-classic-header {
  height: 72px !important;
  border-bottom: 1px solid #2b2d3c !important;
}

.pk-classic-header h1 {
  color: #f4ead8 !important;
  font-size: 24px !important;
}

.pk-classic-header h1::before {
  content: "";
  width: 30px;
  height: 30px;
  margin-right: 12px;
  display: inline-block;
  vertical-align: middle;
  background: url("../assets/pizzaking/icon-classic.svg") center / contain no-repeat;
}

.pk-classic-actions button {
  height: 40px !important;
  color: #ecd8b8 !important;
  border: 1px solid rgba(236, 216, 184, 0.34) !important;
  border-radius: 6px !important;
  background: #252837 !important;
}

.pk-classic-main {
  margin-top: 18px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  overflow: hidden !important;
}

.pk-classic-rail {
  background: #1c1d29 !important;
  border-right: 1px solid #2b2d3c !important;
}

.pk-classic-content {
  background: #20222f !important;
}

.pk-classic-hero {
  height: 468px !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(17, 246, 203, 0.08), transparent 40%),
    radial-gradient(ellipse at 50% 80%, rgba(236, 216, 184, 0.06), transparent 62%),
    #20222f !important;
}

.pk-classic-watermark {
  opacity: 0.085 !important;
}

.pk-bank-block {
  left: 28px !important;
  top: 32px !important;
}

.pk-clock-row b {
  width: 50px !important;
  height: 76px !important;
  color: #fff7df !important;
  background: #18232a !important;
  border: 1px solid rgba(17, 246, 203, 0.18) !important;
}

.pk-deposit-zone {
  height: 90px !important;
  background: #20222f !important;
}

.pk-deposit-zone button {
  width: 300px !important;
  height: 42px !important;
  background: linear-gradient(90deg, #11f6cb, #17b4e8) !important;
  box-shadow: 0 0 28px rgba(17, 246, 203, 0.24) !important;
}

.pk-classic-stats {
  margin: 16px 18px 24px !important;
}

.pk-classic-stats article {
  height: 74px !important;
  background: #22313b !important;
  border: 1px solid rgba(17, 246, 203, 0.08) !important;
}
</style>

<style lang="less">
/* 2026-07-05 exact-pass: classic mode darker single-game surface. */
.pk-classic-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  background:
    radial-gradient(ellipse at 50% 220px, rgba(17, 246, 203, 0.07), transparent 460px),
    radial-gradient(ellipse at 50% 390px, rgba(236, 216, 184, 0.04), transparent 520px),
    #191b26 !important;
}

.pk-classic-shell {
  width: 100% !important;
  max-width: none !important;
  padding: 18px 24px 96px !important;
}

.pk-classic-header {
  height: 64px !important;
  padding: 0 20px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px 8px 0 0 !important;
  background: #20222f !important;
}

.pk-classic-main {
  margin-top: 0 !important;
  border-color: #2b2d3c !important;
  border-radius: 0 0 8px 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.pk-classic-hero {
  height: 438px !important;
  background:
    radial-gradient(ellipse at 50% 50%, rgba(17, 246, 203, 0.1), transparent 38%),
    radial-gradient(ellipse at 50% 82%, rgba(236, 216, 184, 0.06), transparent 62%),
    #20222f !important;
}

.pk-classic-skin-strip {
  height: 128px;
  position: absolute;
  z-index: 3;
  inset: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.065);
  background: rgba(22, 25, 36, 0.72);
}

.pk-classic-skin-card {
  min-width: 0;
  padding: 10px 12px 8px;
  display: grid;
  grid-template-rows: 76px auto auto;
  align-items: center;
  justify-items: center;
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  background: linear-gradient(180deg, rgba(47, 56, 83, 0.34), rgba(26, 29, 42, 0.72));
}

.pk-classic-skin-card:last-child { border-right: 0; }

.pk-classic-skin-card img {
  width: 138px;
  max-width: 100%;
  height: 72px;
  object-fit: contain;
  filter: drop-shadow(0 7px 9px rgba(0, 0, 0, 0.36));
}

.pk-classic-skin-placeholder {
  width: 86px !important;
  height: 8px;
  display: block;
  border-radius: 99px;
  background: linear-gradient(90deg, transparent, rgba(108, 125, 213, 0.7), transparent);
  box-shadow: 0 0 24px rgba(85, 107, 230, 0.5);
}

.pk-classic-skin-card span {
  width: 100%;
  overflow: hidden;
  color: #e8ebf6;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pk-classic-skin-card em {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f5c758;
  font-size: 12px;
  font-style: normal;
  font-weight: 1000;
}

.pk-classic-skin-card em i {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.pk-classic-page.pk-account-panel .pk-bank-block {
  top: 164px !important;
}

.pk-classic-page.pk-account-panel .pk-classic-clock {
  top: 151px;
}

.pk-classic-current-player {
  position: absolute;
  z-index: 3;
  left: 50%;
  top: 299px;
  display: grid;
  grid-template-columns: 38px auto;
  align-items: center;
  column-gap: 9px;
  color: #edf0fb;
  transform: translateX(-50%);
}

.pk-classic-player-avatar,
.pk-classic-stat-avatar {
  display: grid;
  place-items: center;
  color: #9da8c1;
  background: radial-gradient(circle at 38% 28%, #596078, #252938 68%);
  border: 2px solid rgba(97, 115, 177, 0.72);
  border-radius: 50%;
  font-weight: 1000;
}

.pk-classic-player-avatar {
  width: 38px;
  height: 38px;
  grid-row: span 2;
}

.pk-classic-current-player strong {
  font-size: 13px;
  font-weight: 1000;
  white-space: nowrap;
}

.pk-classic-current-player em {
  color: #1edfc8;
  font-size: 12px;
  font-style: normal;
  font-weight: 1000;
}

.pk-classic-page.pk-account-panel .pk-chance-block { top: 169px; }
.pk-classic-page.pk-account-panel .pk-items-counter { bottom: 22px; }
.pk-classic-page.pk-account-panel .pk-rule-block { bottom: 21px; }

.pk-classic-clock {
  filter:
    drop-shadow(0 0 26px rgba(17, 246, 203, 0.12))
    drop-shadow(0 22px 28px rgba(0, 0, 0, 0.28)) !important;
}

.pk-deposit-zone {
  height: 82px !important;
  border-top: 1px solid #2b2d3c !important;
}

.pk-classic-stats {
  gap: 8px !important;
  margin: 8px 10px 18px !important;
}

.pk-classic-stats article {
  height: 118px !important;
  padding: 0 22px !important;
  display: grid !important;
  grid-template-columns: 52px minmax(0, 1fr);
  align-items: center;
  gap: 14px;
  border-radius: 7px !important;
  background: #252837 !important;
}

.pk-classic-stat-avatar {
  width: 50px;
  height: 50px;
}

.pk-classic-stats strong,
.pk-classic-stats b,
.pk-classic-stats small { display: block; }
.pk-classic-stats strong { color: #f5c758 !important; font-size: 12px !important; letter-spacing: 0.06em; }
.pk-classic-stats b { margin-top: 4px; color: #edf0fb; font-size: 15px; }
.pk-classic-stats small { margin-top: 5px; color: #8790a7; font-size: 11px; }

@media (max-width: 900px) {
  .pk-classic-skin-strip { grid-template-columns: repeat(3, minmax(0, 1fr)); height: 154px; }
  .pk-classic-skin-card:nth-child(n + 4) { display: none; }
  .pk-classic-page.pk-account-panel .pk-bank-block { top: 184px !important; }
  .pk-classic-page.pk-account-panel .pk-classic-clock { top: 184px; }
  .pk-classic-page.pk-account-panel .pk-chance-block { top: 182px; }
  .pk-classic-current-player { top: 329px; }
}

@media (min-width: 901px) {
  .pk-classic-shell {
    padding: 0 0 96px !important;
  }

  .pk-classic-header {
    height: 80px !important;
    padding: 0 35px 0 30px !important;
    border: 0 !important;
    border-bottom: 1px solid #2b2d3c !important;
    border-radius: 0 !important;
    background: transparent !important;
  }

  .pk-classic-main {
    margin-top: 0 !important;
    grid-template-columns: 44px minmax(0, 1fr) !important;
    border-radius: 0 !important;
  }

  .pk-classic-rail {
    width: 44px !important;
    min-height: 820px !important;
    padding-top: 20px !important;
  }

  .pk-classic-hero {
    height: 262px !important;
  }

  .pk-classic-page.pk-account-panel .pk-bank-block {
    top: 45px !important;
  }

  .pk-classic-page.pk-account-panel .pk-classic-clock {
    top: 54px !important;
  }

  .pk-classic-page.pk-account-panel .pk-chance-block {
    top: 38px !important;
  }

  .pk-classic-page.pk-account-panel .pk-items-counter {
    bottom: 35px !important;
  }

  .pk-classic-page.pk-account-panel .pk-rule-block {
    bottom: 33px !important;
  }

  .pk-deposit-zone {
    height: 100px !important;
  }

  .pk-classic-stats {
    margin: 0 34px 24px !important;
    gap: 20px !important;
  }

  .pk-classic-stats article {
    height: 78px !important;
    padding: 0 !important;
    display: grid !important;
    grid-template-columns: 1fr !important;
    place-items: center !important;
    text-align: center;
  }

  .pk-classic-stats b {
    margin-top: 3px !important;
  }
}
</style>
